<template>
  <div class="organization-editor responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader :pageHeader="pageHeader" :hideAddButton="true" :selectedEntity="selectedSettings" :links="[
        { name: 'home', label: 'Home' },
        {
          name: 'reports',
          label: 'Reports',
        },
        {
          name: 'reportSettings',
          label: 'Report Settings',
        },
      ]" @toggle-edit="toggleEdit" @updateIsEdit="isEdit = $event" @on-post-save="onPostSave" :canArchive="false"
        :isEdit="isEdit" :entity="entity" :isCollapsed="isCollapsed" />
      <!-- <EditorSection title="Report Configurations" sectionType="reports" :bus="bus" :defaultIsOpen="true" :canToggle="false">
         -->
      <div class="section-base">
        <div class="padded elevated-0 bordered">
          <div class="report-count">
            <div class="search-input">
              <SearchInput
                type="text"
                :value="search"
                @updateModel="searchEvent"
                placeholder="Search by Report Name"
                ref="searchInputRef" />
            </div>
            <span v-if="isDFUser" class="df-admin">DF ADMIN</span>
            <inline-button label="Add New Report" type="plain-primary responsive-column form-height wide"
              class="add-new-report" @click="openEditor()" :disabled="!isEdit" />
          </div>
          <table cellspacing="0" class="table-element">
            <thead>
              <tr class="header">
                <th class="cell">Report Name</th>
                <th class="cell">Report Description</th>
                <th class="cell">Report Section</th>
                <th class="cell">Report Sub Section</th>
                <th class="cell">Is DF Report</th>
                <th class="cell">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(report, i) in reportConfigs" :key="report._id" class="row" v-show="shouldShowReport(report)">
                <td class="cell">
                  {{ report.name }}
                </td>
                <td class="cell">
                  {{ report.description }}
                </td>
                <td class="cell">
                  {{ report.section }}
                </td>
                <td class="cell">
                  {{ report.subSection }}
                </td>
                <td class="cell">
                  {{ report.isDFDefault ? 'Yes' : 'No' }}
                </td>
                <td class="cell">
                  <inline-button label="Edit" type="plain-primary responsive-column wide"
                    @click="() => openEditor(report)" :disabled="!isEdit || (!isDFUser && report.isDFDefault)" />
                  <inline-button label="Delete" type="plain-primary responsive-column wide" style="margin-left: 1rem;"
                    class="delete-report" @click="() => deleteConfig(report, i)"
                    :disabled="!isEdit || (!isDFUser && report.isDFDefault)" />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="count-text">Report Count: {{ reportConfigs.length }}</div>
        </div>
      </div>

      <EditorSection title="Settings" sectionType="reportSettings" :bus="bus" :defaultIsOpen="true" :canToggle="false">
        <div class="two-columns-layout two-columns-layout--responsive">
          <div class="
                grid-two-column
                two-columns-layout--responsive-horizontal-space-10
              ">
            <div v-for="input in mainInputs" :key="input.id" :class="'input-text' + ' ' + input.class">
              <Input :model="selectedSettings[input.id]" @updateModel="selectedSettings[input.id] = $event"
                :inputData="{...input, disabled: input.id === 'supersetBaseUrl' && !isDFUser}" :isEdit="isEdit" />
            </div>
          </div>
        </div>
      </EditorSection>

      <EditorSection :title="`About ${selectedSettings.name || ''}`" sectionType="about"
        v-if="selectedSettings._id !== 'NEW'" :bus="bus">
        <About v-if="selectedSettings._id !== undefined" :entity="selectedSettings" />
      </EditorSection>

      <BaseModal v-if="showReportEditor" @toggle-modal="showReportEditor = false" title="Report Editor">
        <div style="padding: 1rem; display: flex; flex-direction: column; gap: 1rem;">
          <p>To create a new report, <a class="url-text" :href="selectedSettings.supersetBaseUrl" target="_blank">login
              to Superset</a> and create a new dashboard.</p>
          <div class="two-columns-layout two-columns-layout--responsive">
            <div class="
                grid-two-column
                two-columns-layout--responsive-horizontal-space-10
              ">
              <div v-for="input in defaultReportConfigs" :key="input.id" class="salePricing__input input-text"
                :class="input.class">
                <Input :model="currentReportConfig[input.id]" @updateModel="currentReportConfig[input.id] = $event"
                  :inputData="input" :isEdit="isEdit" />
              </div>
            </div>
          </div>
          <div class="right">
            <inline-button label="Done" type="plain-primary responsive-column form-height wide" @click="addConfig"
              :disabled="!isEdit" />
          </div>
        </div>
      </BaseModal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import PageHeader from "@/components/PageHeader.vue";
import About from "@/components/About/About.vue";
import EditorSection from "@/components/EditorSection.vue";
import { mapActions, mapGetters } from "vuex";
import Constants from "@/resources/Constants";
import Input from "@/components/Input/Input.vue";
import { mainInputs, pageHeader, reportConfigSchema, defaultReportConfig } from "./inputs";
import Entities from "@/resources/Entities";
import BaseModal from "@/components/Modals/BaseModal/BaseModal.vue";
import SearchInput from "@/components/Base/Input/SearchInput.vue";

export default {
  name: "reportSettingsEditor",
  data() {
    return {
      Constants: Constants,
      mainInputs,
      isEdit: false,
      isCollapsed: true,
      bus: new Vue(),
      entity: Entities.REPORTSETTINGS,
      pageHeader,
      defaultConfig: defaultReportConfig,
      reportConfigSchema,
      showReportEditor: false,
      currentReportConfig: null,
      isNewReportConfig: false,
      search: '',
      filterQuery: '',
      debounceTimer: null,
    };
  },
  components: {
    PageHeader,
    About,
    BaseModal,
    EditorSection,
    Input,
    SearchInput,
  },
  watch: {
    search(newVal) {
      console.log('search', newVal);
    },
    isEdit(newVal, oldVal) {
      this.$nextTick(() => {
        const inputEl = this.$refs.searchInputRef?.$refs?.inputDiv;
        if (inputEl) {
        }
      });
    },
    reportSettings: {
      handler(newVal, oldVal) {
        if (newVal && newVal._id) {
          this.$nextTick(() => {
            const inputEl = this.$el?.querySelector('.search-input input');
            if (inputEl) {
              if (inputEl.readOnly) {
                inputEl.readOnly = false; // this forces the search input to be editable
                inputEl.style.backgroundColor = '';
              }
            }
          });
        }
      },
      deep: true
    }
  },
  mounted: function () {
    this.setPageTitle("Report Settings");
    this.getReportSettings();
  },
  computed: {
    ...mapGetters({
      loadingStatus: "reports/loadingStatus",
      reportSettings: "reports/reportSettings",
      getUser: "loginModule/user",
    }),
    reportConfigs() {
      return (this.reportSettings?.reportConfigs || [])
        .slice()
        .sort((a, b) => {
          if (a.section === b.section) {
            if (a.subSection === b.subSection) {
              return a.name.localeCompare(b.name);
            }
            return a.subSection?.localeCompare(b.subSection);
          }
          return a.section?.localeCompare(b.section);
        });
    },
    selectedSettings: {
      get() {
        return this.reportSettings;
      },
      set(entity) {
        return entity;
      },
    },
    isDFUser() {
      return this.getUser.email.includes('@dispensefirst.com');
    },
    defaultReportConfigs() {
      return this.isDFUser ? this.reportConfigSchema : this.reportConfigSchema.filter(c => c.id !== 'isDFDefault');
    },
  },
  methods: {
    ...mapActions({
      setMessage: "setMessage",
      setMessagePopUp: "setMessagePopUp",
      getReportSettings: "reports/getReportSettings",
      saveReportSettings: "reports/saveReportSettings",
      setReportSettings: "reports/setReportSettings",
    }),
    searchEvent(newValue) {
      this.search = newValue ?? '';
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.filterQuery = this.search;
      }, 300);
    },
    getInput(field) {
      return this.mainInputs.find((i) => i.id == field);
    },
    performSave() {
      this.saveReportSettings(this.selectedSettings);
    },
    onPostSave(data) {
      this.setReportSettings(data.updatedEntity);
    },
    normalizeEntityBeforeSaving(organization) {
      const entity = JSON.parse(JSON.stringify(organization));
      return entity;
    },
    toggleEdit() {
      if (!(this.selectedSettings._id === "NEW"))
        this.isEdit = !this.isEdit;
      if (this.selectedSettings._id === "NEW") {
        this.isEdit = true;
      }
    },
    addConfig() {
      if (this.isNewReportConfig) {
        this.selectedSettings.reportConfigs.push(this.currentReportConfig);
      }
      this.showReportEditor = false;
    },
    deleteConfig(report, i) {
      this.setMessagePopUp({
        isOpen: true,
        title: Constants.strings.warningMessageTitle,
        message: Constants.strings.deletionConfirmation,
        positiveCallback: (data) => {
          const index = this.selectedSettings.reportConfigs.findIndex(r => r._id === report._id || (r.slug === report.slug && r.section === report.section && r.subSection === report.subSection));
          this.selectedSettings.reportConfigs.splice(index, 1);
        },
      });
    },
    openEditor(report) {
      if (report) {
        this.isNewReportConfig = false;
        this.currentReportConfig = report;
      } else {
        this.isNewReportConfig = true;
        this.currentReportConfig = JSON.parse(JSON.stringify(this.defaultConfig));
      }
      this.showReportEditor = true;
    },
    shouldShowReport(report) {
      const query = this.filterQuery.toLowerCase();
      return query == '' || (report.name && report.name.toLowerCase().includes(query));
    },
  }
};
</script>

<style scoped lang="scss">
.add-new-report {
  width: 20rem;
  float: right;
}

.report-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.delete-report {
  background-color: rgba($light-cancel-color, 0.1);
  color: $light-cancel-color;

  &:hover {
    border-color: $light-cancel-color;
  }
}

.df-admin {
  padding: 0.5rem 1rem;
  background-color: rgba($light-danger-color, 0.1);
  color: $light-danger-color;
}

.url-text {
  color: $dark-accent-color !important;
  cursor: pointer;
}

.count-text {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
}

.search-input {
  min-width: 20rem;
}
</style>
